import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

export function ReportIcon({ height, width }: SimpleIconInterface): JSX.Element {
  const gradientId = useSvgId('report-icon-gradient');

  return (
    <SimpleIcon height={height ?? 24} viewBoxDimensions="0 0 24 24" width={width ?? 24}>
      <path
        clipRule="evenodd"
        d="M20.375 22.313c.76 0 1.375-.616 1.375-1.375V5.704c0-.37-.15-.725-.415-.984l-2.708-2.643a1.375 1.375 0 0 0-.96-.39H3.874c-.76 0-1.375.615-1.375 1.375v17.875c0 .759.616 1.375 1.375 1.375h16.5zM17.25 9.48c0-.681-.576-1.2-1.25-1.2h-2c-.674 0-1.25.519-1.25 1.2v7.8h-1.5V12.46c0-.679-.583-1.179-1.25-1.179H8c-.667 0-1.25.5-1.25 1.179v4.821h-.252a.75.75 0 1 0 0 1.5H17.328a.75.75 0 0 0 0-1.5h-.078v-7.8zm-1.5 7.8h-1.5v-7.5h1.5v7.5zm-7.5 0h1.5v-4.5h-1.5v4.5z"
        fill={`url(#${gradientId})`}
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={gradientId}
          x1="12.37"
          x2="-7.782"
          y1="-8.416"
          y2="10.294"
        >
          <stop stopColor="#FA715B" />
          <stop offset="1" stopColor="#CB3E6D" />
        </linearGradient>
      </defs>
    </SimpleIcon>
  );
}
